import { useUserQuery } from 'api/user/queries'

import type { FeatureFlag } from 'consts/featureFlags'

export const useFeatureFlag = (featureFlag: FeatureFlag) => {
  const { data: userFeatureFlags } = useUserQuery({
    select: ({ user: { featureFlags } }) => featureFlags,
  })

  return userFeatureFlags?.includes(featureFlag)
}
